import React from "react";
import { IAutomobileDriverConviction } from "../../../../../../../redux/automobileDriver/automobileDriver.types";
import { RightPanel } from "../../../../../../../components/RightPanel";
import { AutomobileConvictionInformation } from "./AutomobileDriverConviction";

interface IAutomobileDriverConvictionRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  incrementalNumber?: number;
  onSaveSuccess: (driverConviction: IAutomobileDriverConviction) => void;
  readonly?: boolean;
  staticStatusValue?: string;
  created_from?: string;
  onClose: () => void;
  initialData?: IAutomobileDriverConviction;
  disableApiCalls?: boolean;
}

export const AutomobileDriverConvictionRightPanel: React.FC<
IAutomobileDriverConvictionRightPanelProps
> = (props) => {
  const {
    customerId,
    customerPolicyId,
    incrementalNumber,
    onClose,
    onSaveSuccess,
    readonly,
    staticStatusValue,
    created_from,
    initialData,
    disableApiCalls,
  } = props;

  return (
    <>
      <RightPanel
        heading="Driver Conviction"
        //subHeading="Add notes or comments"
        open={true}
        onClose={onClose}
        width="80%"
      >
        <AutomobileConvictionInformation
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          incrementalNumber={incrementalNumber}
          onSaveSuccess={onSaveSuccess}
          readOnly={readonly}
          fromRightPanel
          staticStatusValue={staticStatusValue}
          created_from={created_from}
          initialData={initialData}
          disableApiCalls={disableApiCalls}
        />
      </RightPanel>
    </>
  );
};
